(() => {
  const config = window.presaleGate;
  if (!config?.enabled) return;

  const launchTime = Number(config.launchEpoch) * 1000;
  const serverTimeAtLoad = Number(config.serverNowEpoch) * 1000;
  if (!Number.isFinite(launchTime) || !Number.isFinite(serverTimeAtLoad)) {
    document.documentElement.classList.add('presale-gate-locked');
    console.error('Presale gate: server timing configuration is invalid.');
    return;
  }

  const root = document.documentElement;
  const performanceAtLoad = performance.now();
  let timer;

  const initializeNotifyFeedback = () => {
    let targetId = '';
    try {
      targetId = decodeURIComponent(window.location.hash.slice(1));
    } catch {
      targetId = window.location.hash.slice(1);
    }

    document.querySelectorAll('.presale-notify__form').forEach((form) => {
      const feedback = form.querySelector('[data-presale-notify-feedback]');
      if (!feedback) return;

      const input = form.querySelector('input[name="contact[email]"]');
      if (form.id !== targetId) {
        input?.removeAttribute('aria-invalid');
        input?.removeAttribute('aria-describedby');
        if (input) input.value = '';
        return;
      }

      feedback.hidden = false;
      if (feedback.dataset.presaleNotifyFeedback === 'success') {
        const fields = form.querySelector('[data-presale-notify-fields]');
        if (fields) fields.hidden = true;
      }
      feedback.focus({ preventScroll: true });
    });
  };

  const currentTime = () => serverTimeAtLoad + (performance.now() - performanceAtLoad);
  const isLocked = () => currentTime() < launchTime;
  const pad = (value) => String(value).padStart(2, '0');

  const blockPurchase = (event) => {
    if (!isLocked()) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  };

  const isPurchaseControl = (target) => {
    if (!(target instanceof Element)) return false;

    return Boolean(target.closest(
      '[name="add"], [name="checkout"], [data-presale-purchase], ' +
      '.product-card--add-to-cart-button-simple, .product-card-sizes--size, ' +
      '.shopify-payment-button, a[href*="/checkout"], a[href^="/cart/"]'
    ));
  };

  const isPurchaseForm = (form, submitter) => {
    if (!(form instanceof HTMLFormElement)) return false;
    if (submitter?.name === 'checkout' || submitter?.name === 'add') return true;

    try {
      const action = new URL(form.action, window.location.origin).pathname;
      return action.endsWith('/cart/add');
    } catch {
      return false;
    }
  };

  const reloadForLaunch = () => {
    const url = new URL(window.location.href);
    url.searchParams.set('_presale_open', String(Math.floor(Date.now() / 1000)));
    window.location.replace(url.toString());
  };

  const updateCountdowns = () => {
    const distance = Math.max(0, launchTime - currentTime());
    const days = Math.floor(distance / 86400000);
    const hours = Math.floor((distance % 86400000) / 3600000);
    const minutes = Math.floor((distance % 3600000) / 60000);
    const seconds = Math.floor((distance % 60000) / 1000);

    document.querySelectorAll('[data-presale-countdown]').forEach((countdown) => {
      countdown.querySelector('[data-presale-days]').textContent = pad(days);
      countdown.querySelector('[data-presale-hours]').textContent = pad(hours);
      countdown.querySelector('[data-presale-minutes]').textContent = pad(minutes);
      countdown.querySelector('[data-presale-seconds]').textContent = pad(seconds);
      countdown.querySelector('[role="timer"]').setAttribute(
        'aria-label',
        `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds`
      );
    });

    if (distance === 0) {
      window.clearInterval(timer);
      window.setTimeout(reloadForLaunch, config.serverLocked ? 1000 : 0);
    }
  };

  document.addEventListener('click', (event) => {
    if (isPurchaseControl(event.target)) blockPurchase(event);
  }, true);

  document.addEventListener('submit', (event) => {
    if (isLocked() && isPurchaseForm(event.target, event.submitter)) {
      blockPurchase(event);
    }
  }, true);

  initializeNotifyFeedback();

  if (!isLocked()) {
    if (config.serverLocked) {
      root.classList.add('presale-gate-locked');
      updateCountdowns();
    } else {
      root.classList.remove('presale-gate-locked');
      const url = new URL(window.location.href);
      if (url.searchParams.has('_presale_open')) {
        url.searchParams.delete('_presale_open');
        window.history.replaceState({}, '', url.toString());
      }
    }
    return;
  }

  root.classList.add('presale-gate-locked');
  updateCountdowns();
  timer = window.setInterval(updateCountdowns, 1000);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) updateCountdowns();
  });
})();
